/**
 * Created by jacky on 5/20/16.
 * @flow
 * @providesModule Dialogs
 */
import React, { Component } from 'react';
import Signup  from './Signup/signup';
import Login from './Login/login';
import ImageViewer from './ImageViewer/imageViewer';
import {addClass, removeClass} from '../../lib/stories-shared';
import { GA } from '../../lib/analytics';

import CSSTransition from 'react-addons-css-transition-group';

import './dialogs.scss';


export const DIALOG = {
    None: 0,
    SignUp: 1,
    Login: 2,
    imageViewer: 3
}

type DialogsPropsType = {
    projectName: string;
    contentPool: string;
    contentId: string;
}
type DialogsStateType = {
    dialog: number;
    data?: any;
}



export default class Dialogs extends Component {
    props: DialogsPropsType;
    state: DialogsStateType = {
        dialog: DIALOG.None,
        data: null
    };
    _touchHandler: ?() => void;
    _savedScrollPos: number;

    _onEscHandler = () => {
        if ([DIALOG.SignUp, DIALOG.Login].indexOf(this.state.dialog) > -1) {
            GA({category: 'Acquire', action: this.state.dialog == DIALOG.SignUp ? 'CloseSignUp' : 'CloseLogin', value: void 0});
        }
        this.setState({dialog: DIALOG.None});
    }

    componentWillUpdate(nextProps: DialogsPropsType, nextState: DialogsStateType) {
        if ([DIALOG.SignUp, DIALOG.Login].indexOf(nextState.dialog) > -1) {
            GA({category: 'Acquire', action: nextState.dialog == DIALOG.SignUp ? 'OpenSignUp' : 'OpenLogin', value: void 0})
        }
    }

    render () {
        let popup;

        switch (this.state.dialog) {
            case DIALOG.SignUp:
                popup = (
                    <Signup
                        projectName={this.props.projectName}
                        onLoginClicked={e => this.setState({dialog: DIALOG.Login})}
                        contentPool={this.props.contentPool}
                        contentId={this.props.contentId}
                        onEsc={this._onEscHandler}
                    />
                );
                break;
            case DIALOG.Login:
                popup = (
                    <Login
                        projectName={this.props.projectName}
                        contentPool={this.props.contentPool}
                        contentId={this.props.contentId}
                        onEsc={this._onEscHandler}
                    />
                );
                break;
            case DIALOG.imageViewer:
                popup = (
                    <ImageViewer
                        data={this.state.data}
                        onEsc={this._onEscHandler}
                    />
                );
                break;
            default:
                popup = null;
                break;
        }

        if (popup) {
            const b = document.querySelector('body');
            this._savedScrollPos = window.scrollY;

            addClass(b, 'clsDialogShown');
            if ([1,2].indexOf(this.state.dialog) > -1) {
                addClass(b, 'clsDialogExt');
            } else {
                if (!this._touchHandler) {
                    this._touchHandler  = (ev: any) => ev.preventDefault();
                    b.addEventListener('touchmove', this._touchHandler);
                }
            }

            return (
                <CSSTransition
                    transitionName="clsDialogAnimation"
                    transitionAppear={true}
                    transitionEnterTimeout={300}
                    transitionAppearTimeout={300}
                    transitionLeaveTimeout={300}>
                    <div className="clsPopupShield">
                        <div className="clsCrossIcon" onClick={this._onEscHandler}>
                            <svg>
                                <use xlinkHref="#clsCrossIcon" />
                            </svg>
                        </div>
                        {popup}
                    </div>
                </CSSTransition>
            )
        } else {
            const b = document.querySelector('body');
            removeClass(b, 'clsDialogShown clsDialogExt');
            setTimeout(() => window.scrollTo(0, this._savedScrollPos));

            if (this._touchHandler) {
                b.removeEventListener('touchmove', this._touchHandler);
                this._touchHandler = null;
            }
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/dialogs.jsx